import { createFileRoute } from "@tanstack/react-router";

import { JsonLd } from "@/components/site/JsonLd";
import { CtaBand, PageCard } from "@/components/site/Sections";
import { SiteLayout } from "@/components/site/SiteLayout";
import { categoryLabels, servicePages } from "@/data/pages";
import type { ServicePage } from "@/data/types";
import { breadcrumbSchema, canonicalLink, metaFor } from "@/lib/seo";

const title = "Serviços de Chaveiro em Betim | Chavel Chaveiro";
const description =
  "Todos os serviços da Chavel em Betim: chaveiro 24 horas, automotivo, chave codificada, fechaduras, fechadura digital, controles de portão e atendimento por bairro.";

export const Route = createFileRoute("/servicos")({
  head: () => ({
    meta: metaFor({ title, description, path: "/servicos" }),
    links: canonicalLink("/servicos"),
  }),
  component: ServicosPage,
});

const order: ServicePage["category"][] = ["emergencia", "automotivo", "bairro", "produto", "geral"];

function ServicosPage() {
  return (
    <SiteLayout>
      <JsonLd
        data={breadcrumbSchema([
          { name: "Início", url: "/" },
          { name: "Serviços", url: "/servicos" },
        ])}
      />

      <section className="bg-surface text-surface-foreground">
        <div className="container-page py-14">
          <h1 className="font-display text-4xl">Serviços de chaveiro em Betim</h1>
          <p className="mt-4 max-w-3xl opacity-90">
            Cada serviço tem uma página com explicação completa, prazos, o que levamos e perguntas frequentes. Escolha
            abaixo a situação mais próxima da sua.
          </p>
        </div>
      </section>

      {order.map((category) => {
        const pages = servicePages.filter((page) => page.category === category);
        if (!pages.length) return null;
        return (
          <section key={category} className="container-page py-10">
            <h2 className="font-display text-2xl">{categoryLabels[category]}</h2>
            <div className="mt-6 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {pages.map((page) => (
                <PageCard key={page.slug} page={page} />
              ))}
            </div>
          </section>
        );
      })}

      <CtaBand
        title="Não achou o seu caso na lista?"
        text="Fale com a Chavel: atendemos praticamente todo tipo de chave, fechadura e automação em Betim."
      />
    </SiteLayout>
  );
}
